import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useDocumentOverflowLockedEffect as l } from './document-overflow/use-document-overflow.js';
import { useIsTopLayer as m } from './use-is-top-layer.js';
function f(e, c) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return [document.body];
  };
  var r = m(e, "scroll-lock");
  l(r, c, function (t) {
    var o;
    return {
      containers: [].concat(_toConsumableArray((o = t.containers) != null ? o : []), [n])
    };
  });
}
export { f as useScrollLock };